import { IAgEventModelMethods } from "../model";
import {
    IAgEventPlanting,
    IEventPlantingVarietyHybrid,
} from "@ai360/core/dist/4x/es/api/ag-event/ag-event.4x";

export class AgEventPlanting implements IAgEventModelMethods, IAgEventPlanting {
    agEventGuid = "";
    cropGuid: string | null = "";
    cropName: string | null = "";
    cropClassNameGuid: string | null = null;
    cropPurposeGuid: string | null = "";
    cropPurposeName: string | null = "";
    plantingDepth: number | null = null;
    plantingDepthIaGuid: string | null = null;
    rowSpacing: number | null = null;
    rowSpacingIaGuid: string | null = null;
    rowOrientationGuid: string | null = null;
    isImportedYn = false;
    transplantYn = false;
    plantSpacing: number | null = null;
    plantSpacingIaGuid: string | null = null;
    transplantTypeGuid: string | null = null;
    plantingPatternGuid: string | null = null;
    cropAgeWhenPlanted: number | null = null;
    cropAgeIaGuid: string | null = null;
    commodityGuid: string | null = null;
    commodityTypeGuid: string | null = null;
    intendedUseGuid: string | null = null;
    croppingPracticeGuid: string | null = null;
    eventPlantingVarietyHybridList: IEventPlantingVarietyHybrid[] = [];

    get isAllRequiredFieldsSet(): boolean {
        // FYI: If this gets set to false, the zone in question gets it's applyEventToArea set to false automatically.
        // Use with *extreme* caution
        return Boolean(this.cropGuid && this.checkImportedVH());
    }

    get isAnyRequiredFieldSet(): boolean {
        return Boolean(this.cropGuid && this.cropGuid.length);
    }

    checkImportedVH(): boolean {
        if (
            !this.isImportedYn ||
            !this.eventPlantingVarietyHybridList ||
            this.eventPlantingVarietyHybridList.length <= 0
        ) {
            return true;
        }
        return Boolean(
            this.eventPlantingVarietyHybridList.every(
                (vh) => vh.brandOrganizationGuid && vh.varietyHybridGuid
            )
        );
    }

    myAgDataIncomplete(): boolean {
        return (
            this.commodityGuid &&
            !(this.commodityTypeGuid && this.intendedUseGuid && this.croppingPracticeGuid)
        );
    }

    updateAgEventModel(newProps): AgEventPlanting {
        return Object.assign(new AgEventPlanting(), this, newProps);
    }
}
